import React, {Component} from "react";
import PropTypes from 'prop-types';
import {getSize, colors} from "./../../cc-imports";
// import './cc-counter-item.css'
import './cc-counter-item-320x720.css'
import './../../styles/css/components/CCCounter/cc-counter-item.css'

class CCCounterItem extends Component {

    constructor(props) {
        super(props)
    }

    static propTypes = {

    }
    static defaultProps = {
        title: 'Hours'
    }

    render() {
        const {style, title, value} = this.props;

        return (
            <div style={style}>
                <div className={'flex-container counter-title-container'} >
                    <h2 className={'title'}>{title}</h2>
                </div>
                <div className={'flex-container counter-value-container'} >
                    <h2 className={'title'}>{value}</h2>
                </div>
            </div>
        );
    }
}

export default CCCounterItem


// WEBPACK FOOTER //
// ./src/app/components/CCCounter/CCCounterItem.js